import PublicApi from './public/publicApi';

export const SERVICES = {
  public: new PublicApi(),
};
